import React, { FC, useEffect, useState } from "react"
import { FaPlus } from "react-icons/fa"
import deleteIcon from '@/assets/icons/deleteIcon.svg'
import SelectSearchInput from "../selectInput/SelectSearchInput";
import { Button, convertCentsToDollars, Loader } from "@thdinc/hpf-shared";
import { Controller, useForm } from "react-hook-form";
import { StoreList } from "@/pages/alcohalAndMixers/interface";
import Alert from "../alert/Alert";
import { GET, PATCH, POST } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";
interface Product {
    id: string,
    type: string,
    name: string,
    image: string,
    quantity: number,
    size: number,
    price: number,
    status: string,
    created_at: string,
    updated_at: string,
    store_id: string,
    title?: string
}

interface ProductCardProps {
    product: Product;
    onRemove: (id: string) => void;
    onEditProduct: (product: Product) => void;

}

interface ProductModalParams {
    isOpen: boolean;
    storeType: any[];
}

interface AlcohalCardProps {
    products: Product[];
    onhandleRemove: (id: string) => void;
    setEditProduct: (product: Product) => void;
    showPreferredSection?: boolean;
    header: { title: string; type: string[] }
    setProductModal: (params: ProductModalParams) => void
    selectedStore?: StoreList
    isloading?: boolean
    activeTab?: string
    setUnSavedPreference?: (flag: boolean) => void;
}

interface PreferenceForm {
    preferenceOne: string;
    preferenceTwo: string;
    preferenceThree: string;
    Bonus: number;
}

const AlcohalCard: FC<AlcohalCardProps> = ({ products, onhandleRemove, showPreferredSection, setProductModal, header, setEditProduct, isloading, selectedStore, activeTab, setUnSavedPreference }) => {
    const [showNoProductsMessage, setShowNoProductsMessage] = useState(false);
    const { refreshToken } = useAppSelector((store) => store.user);
    const [preferenceLoading, setPreferenceLoading] = useState<boolean>(false);
    const [preferenceToggle, setPreferenceToggle] = useState<boolean>(false);
    const [preferenceId, setPreferenceId] = useState<string | null>(null);
    const { productsPreferences } = API_ROUTES;
    const {
        formState: { errors },
        register,
        handleSubmit,
        setValue,
        watch,
        control,
        getValues,
        reset,
        trigger
    } = useForm<PreferenceForm>();

    useEffect(() => {
        if (!isloading && products.length === 0) {
            const timer = setTimeout(() => {
                setShowNoProductsMessage(true);
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            setShowNoProductsMessage(false);
        }
    }, [isloading, products]);
    useEffect(() => {
        if (selectedStore && selectedStore?.id) {
            const fetchPreferences = async () => {
                try {
                    const res = await GET(`${productsPreferences}/${selectedStore?.id}?type=${header.type[0]}`, refreshToken);
                    const prefs = res?.data?.length > 0 ? res.data[0] : null;
                    setPreferenceId(prefs?.id ?? null);
                    // reset the whole form so values from a previously selected store don't carry over
                    reset({
                        preferenceOne: prefs?.prefer1?.id ?? '',
                        preferenceTwo: prefs?.prefer2?.id ?? '',
                        preferenceThree: prefs?.prefer3?.id ?? '',
                        Bonus: prefs?.bonus ? Number((prefs.bonus / 100).toFixed(2)) : 0,
                    });
                } catch (error) {
                    Alert({ type: 'error', message: 'Unable to fetch product preferences' });
                }
            }
            fetchPreferences();

        }
    }, [isloading, selectedStore]);
    const formatName = (text: string) => text.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
    const structurePreferences = products.map(product => ({
        name: product.name,
        value: product.id
    }));
    const preferenceOne = watch("preferenceOne");
    const preferenceTwo = watch("preferenceTwo");
    const preferenceThree = watch("preferenceThree");
    useEffect(() => {
        if (!preferenceOne) {
            setValue('Bonus', 0)
        }
    }, [preferenceOne])
    useEffect(() => {
        if (setUnSavedPreference)
            setUnSavedPreference(preferenceToggle);
    }, [preferenceToggle])
    const getAvailablePreferences = (current: string) => {
        const selectedValues = [preferenceOne, preferenceTwo, preferenceThree].filter(
            val => val && val !== current
        );
        return structurePreferences.filter(pref => !selectedValues.includes(pref.value));
    };
    const handleDeleteProduct = (productId: string) => {
        const isProduct = [getValues('preferenceOne'),
        getValues('preferenceTwo'),
        getValues('preferenceThree')].find(id => id == productId)
        if (isProduct) {
            Alert({ type: 'error', message: 'Unable to delete. This product is currently set as a preference' });
        } else {
            onhandleRemove(productId)
        }
    }
    const onSubmit = async (data: PreferenceForm) => {
        try {
            const payload = {
                type: header.type[0],
                bonus: String(Number(data.Bonus) || 0),
                ...(data.preferenceOne && { prefer1: data.preferenceOne }),
                ...(data.preferenceTwo && { prefer2: data.preferenceTwo }),
                ...(data.preferenceThree && { prefer3: data.preferenceThree })
            }
            setPreferenceLoading(true);
            setValue('Bonus', Number(data.Bonus) || 0)
            preferenceId
                ? await PATCH(`${productsPreferences}/${preferenceId}`, payload, refreshToken)
                : await POST(`${productsPreferences}/${selectedStore?.id}`, payload, refreshToken);
            Alert({ message: 'Preference Saved' });
        } catch (error) {
            Alert({ type: 'error', message: 'Unable to Save Preferences' });
        } finally {
            setPreferenceLoading(false)
            setPreferenceToggle(false)
        }
    }

    return (
        <div className="bg-white rounded-3xl p-3 px-5">
            <div className="flex flex-col sm:flex-row w-full">
                {/* Product List 66% */}
                <div className={`w-full ${showPreferredSection ? 'sm:w-4/6' : 'sm:w-full'} flex flex-col flex-wrap gap-3`}>
                    <div className="flex flex-row items-center justify-between">
                        <h1 className="font-semibold text-xl">{header.title}</h1>
                        <div onClick={() => setProductModal({ isOpen: true, storeType: header.type.map(type => ({ name: header.type.length > 1 ? formatName(type) : header.title, value: type })) })}
                            className="bg-[#F7F8FA] inline-block p-2 rounded-full mr-4">
                            <FaPlus size={17} />
                        </div>
                    </div>
                    <div className="flex flex-row gap-8 flex-wrap max-h-[340px] overflow-y-auto pr-1">
                        {isloading ?
                            <Loader color="bg-red-500" />
                            : products.length > 0 ?
                                products.map((product) => (
                                    <ProductCard key={product.id} product={{ ...product, title: header.title }} onRemove={handleDeleteProduct} onEditProduct={setEditProduct} />
                                )) : <div className="flex w-full justify-center items-center">
                                    {showNoProductsMessage && <p className={`font-semibold text-sm ml-1`}>No Products</p>}
                                </div>
                        }
                    </div>
                </div>
                {/* Sidebar 34% */}
                <div className={`w-full sm:w-1/3 pl-4 pt-6 border-l border-gray-200 ${showPreferredSection ? 'visible' : 'hidden'}`}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="flex flex-col gap-4 sm:flex-row sm:gap-8">
                            <div className=" w-full">
                                <p className="font-semibold  text-xs mb-2 ml-4 ">Preferred #1</p>
                                <Controller
                                    name="preferenceOne"
                                    control={control}
                                    render={({ field, fieldState: { error } }) => {
                                        return (
                                            <>
                                                <SelectSearchInput
                                                    placeholder="Preferred # 1"
                                                    options={getAvailablePreferences(field.value)}
                                                    value={field.value}
                                                    onChange={(selectedValue: string) => {
                                                        field.onChange(selectedValue);
                                                        setPreferenceToggle(true);
                                                    }}
                                                    isCross
                                                />
                                                <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                                    {error?.message}
                                                </p>
                                            </>
                                        )
                                    }}
                                />
                            </div>
                            <div className=" w-full">
                                <p className="font-semibold  text-xs mb-2 ml-4 ">Bonus (%)</p>
                                <input
                                    type="number"
                                    step="0.01"
                                    {...register("Bonus", {
                                        min: {
                                            value: 0,
                                            message: "Bonus must be greater than or equal to 0",
                                        },
                                        max: {
                                            value: 100,
                                            message: "Bonus must be less than or equal to 100",
                                        },
                                        onChange: async (e: any) => {
                                            const value = e.target.value;
                                            if (value.length > 15) {
                                                e.target.value = value.slice(0, 15);
                                            }
                                            const decimalIndex = value.indexOf('.');
                                            if (decimalIndex >= 0 && value.length - decimalIndex > 3) {
                                                e.target.value = value.slice(0, decimalIndex + 3);
                                            }
                                            setPreferenceToggle(true);
                                            await trigger('Bonus')
                                        }
                                    })}
                                    className={`w-full px-4 py-3 bg-p-gray rounded-full ${!getValues('preferenceOne') && 'cursor-not-allowed'} focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600`}
                                    placeholder={"Bonus"}
                                    disabled={getValues('preferenceOne') ? false : true}
                                />
                                <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                    {errors.Bonus?.message}
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-col gap-4 sm:flex-row sm:gap-8 mt-4">
                            <div className=" w-full">
                                <p className="font-semibold  text-xs mb-2 ml-4 ">Preferred #2</p>
                                <Controller
                                    name="preferenceTwo"
                                    control={control}
                                    render={({ field, fieldState: { error } }) => (
                                        <>
                                            <SelectSearchInput
                                                placeholder="Preferred # 2"
                                                options={getAvailablePreferences(field.value)}
                                                value={field.value}
                                                onChange={(selectedValue: string) => {
                                                    field.onChange(selectedValue);
                                                    setPreferenceToggle(true);
                                                }}
                                                isCross
                                            // disabled={getValues('preferenceOne') ? false : true}
                                            />
                                            <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                                {error?.message}
                                            </p>
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col gap-4 sm:flex-row sm:gap-8 mt-4">
                            <div className=" w-full">
                                <p className="font-semibold  text-xs mb-2 ml-4 ">Preferred #3</p>
                                <Controller
                                    name="preferenceThree"
                                    control={control}
                                    render={({ field, fieldState: { error } }) => (
                                        <>
                                            <SelectSearchInput
                                                placeholder="Preferred # 3"
                                                options={getAvailablePreferences(field.value)}
                                                value={field.value}
                                                onChange={(selectedValue: string) => {
                                                    field.onChange(selectedValue);
                                                    setPreferenceToggle(true);
                                                }}
                                                isCross
                                            // disabled={getValues('preferenceOne') && getValues('preferenceTwo') ? false : true}
                                            />
                                            <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                                {error?.message}
                                            </p>
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="text-end">
                            <Button
                                disabled={!preferenceToggle || preferenceLoading}
                                className={`text-center px-6 my-5 rounded-full py-2
                                ${preferenceToggle ? 'bg-primary-red hover:bg-primary-red-button-hover text-white' :
                                        'bg-gray-300 text-gray-500'}
                                `}>
                                {preferenceLoading ? "Saving..." : "Save Preference"}
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default AlcohalCard

const ProductCard: React.FC<ProductCardProps> = ({ product, onRemove, onEditProduct }) => {
    const activeProduct = product.status == 'active'
    return (
        <div className="relative group flex flex-col items-center text-center gap-1">
            <div onClick={() => onEditProduct(product)} className="border border-gray-400 rounded-xl relative group mt-1 w-14 h-14 overflow-hidden">
                <img src={product.image} alt={product.name} className="w-full h-full" />
            </div>
            {!activeProduct && <div
                onClick={() => onEditProduct(product)}
                className="w-14 h-14 bg-gray-300 opacity-50 rounded-xl absolute mt-1" />}
            <button
                onClick={() => onRemove(product.id)}
                className="absolute top-11 right-[-12px] lg:rounded-full lg:opacity-0 lg:group-hover:opacity-100 lg:transition"
            >
                <img src={deleteIcon} />
            </button>

            <p className={`text-xs font-semibold w-16 ${!activeProduct && 'text-gray-400'}`}>{product.name}</p>
            <div className={`flex flex-row ${!activeProduct && 'text-gray-400'}`}>
                <p className="text-xs">{product.quantity}</p>
                <p className="text-xs mx-1">x</p>
                <p className="text-xs">{`${product.size}ml`}</p>
            </div>
            <p className={`text-xs font-medium ${!activeProduct && 'text-gray-400'}`}>${convertCentsToDollars(String(product?.price))}</p>
        </div>
    );
};